import axios from "axios";

const serverUrl = process.env.VUE_APP_URL;

export default {
    data() {
        return {
            clients: [],
            loading: false,
            error: null,
        };
    },
    methods: {
        async getClients() {
            this.loading = true;
            this.error = null;

            try {
                const url = `${serverUrl}Client`;
                const response = await axios.get(url);
                this.clients = response.data.data;
            } catch (err) {
                this.error = "Failed to fetch clients"; // Handle the error
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
